import { ButtonProps, Panel } from '@hover/blueprint';
import React from 'react';
import { animated } from 'react-spring';

import { Button, CustomIcon } from 'src/shared/components';

interface NavButtonProps
  extends Pick<ButtonProps, 'onPress' | 'testId' | 'disabled'> {
  label?: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  style?: React.CSSProperties;
}

const NavButton = ({
  onPress,
  icon,
  testId,
  label,
  disabled,
  style,
}: NavButtonProps) => (
  <animated.div style={style}>
    <Button
      disabled={disabled}
      fill="minimal"
      label={label || 'nav-button'}
      onPress={onPress}
      shape="circle"
      size="large"
      testId={testId}
    >
      <Panel
        alignItems="center"
        borderRadius="50%"
        height="100%"
        justifyContent="center"
        style={{
          pointerEvents: 'auto',
        }}
        width="100%"
      >
        <CustomIcon
          color={disabled ? 'neutral300' : 'neutral700'}
          icon={icon}
          iconHeight="20px"
          iconWidth="20px"
        />
      </Panel>
    </Button>
  </animated.div>
);

export { NavButton };
